import { AppData, Img, Lightning, Log, Utils } from "@lightningjs/sdk";
import { ItemNode } from "../lib/components/grid/ItemNode";
import { AppSetup } from "../lib/app-setup";
import GridViewModel from "../lib/components/grid/grid-view-model";
import { FTPlayerOptions, FTStreamingPlayer } from "../lib/components/ft-streaming-player";
import { Platform } from "../platforms/platform";
import RowList from "../lib/components/grid/row-model";
import { ACTIONTYPE, PLAYERSTATE } from "../lib/enum";
import { events as ftEvents } from "../lib/components/ft-streaming-player/utils";
import { Helper } from "../lib/helper";
import ChannelIcon from "../ui-elements/channel-icon";
import EPGManager from "../lib/components/epg/epg-model";
import EPGGuide from "../lib/components/epg/views/epg-guide";
import { Logger } from "../lib/logger";
import { PreviousVodInfo } from "../lib/models/navigation-stack";
import { Badge, Icon, ProgressBar } from "@lightningjs/ui-components";
import EPGUtility from "../lib/components/epg/epg-utility";
import { getImage } from "../lib/models/data-service";
import AppModel from "../lib/models/app-model";
import { KeyCodes } from "../lib/key-codes";

export interface VideoScreenLiveTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true;
}

export interface VideoScreenLiveTemplateSpec extends Lightning.Component.TemplateSpecLoose {
    Container: {
        ControlWrapper: {},
    }
}

export default class VideoScreenLive extends Lightning.Component<VideoScreenLiveTemplateSpec, VideoScreenLiveTypeConfig> implements Lightning.Component<VideoScreenLiveTemplateSpec>
{

    videoEl!: HTMLVideoElement | null
    platform!: Platform
    ftStreamingPlayer!: FTStreamingPlayer
    channelIndex = 0
    channelRow!: RowList
    grid!: GridViewModel
    videoInfo!: ItemNode
    playerState: any;
    currentTimeExit: number = 0
    isDRM: boolean = false
    isHLS: boolean = false
    isMP4: boolean = false
    videoUrl: string = ''
    prevKeyActionTimeStamp = new Date().getTime()
    changeChannelTimerId: any;
    CHANNEL_SCROLL_DELAY = 500;
    CHANNEL_CHANGE_DELAY = 1000;
    SHOW_CONTROL_DELAY = 5000;
    showControlTimerId: any;

    channelStartTimestamp

    epgManager!:EPGManager
    imageUpdateId: string | number | Timeout | undefined;
    private _imgUrl: string;
    videoElWrapper: HTMLElement;


    static override _template(): Lightning.Component.Template<Lightning.Component.TemplateSpecLoose> {
        return {
            Container: {
                w: 1920,
                h: 1080,
                Background: {
                    w:(w)=>w,
                    h:(h)=>h,
                    src: Utils.asset('images/livetvbg.png')
                },
                ChannelsWrapper: {
                    x: 0, y: 0, w: 400, h: (h: any) => h - 250,
                    flex: {
                        direction: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        alignContent: "center"
                    },
                    ChannelCounter: {
                        h:72,
                        flexItem: { marginBottom: 10, marginTop: 10, marginLeft: -10 },
                        text: {
                            text: "",
                            textAlign: "center"
                        },
                    },
                    IconUp: {
                        h:72,
                        type: ChannelIcon,
                        iconsvg: "ico-up.svg",
                        flexItem: { marginTop: 20 },
                    },
                    ChannelLogo: {
                        w:270,
                        h:210,
                        flexItem: { margin: 0},
                        rect: true,
                        color: 0x00000000,
                        Image: {
                        }
                    },
                    IconDown: {
                        h:72,
                        flexItem: { marginTop: 20},
                        type: ChannelIcon,
                        iconsvg: "ico-down.svg",
                    },
                    TvIcon: {
                        w:270,
                        h:72,
                        flexItem:{ marginTop:225},
                        flex: { direction: "row", justifyContent: "space-between"},
                        LeftArrow: {
                            w:36,
                            h:72,
                            texture: {
                                resizeMode: {type: 'cover', w: 36, h: 72},
                                x:144,y:0,w:72, h:144,
                                type: Lightning.textures.ImageTexture,
                                src: Utils.asset('images/arrows.png')
                            }
                        },
                        Icon: {
                            w:72,
                            h:72,
                            texture: {
                                resizeMode: {type: 'cover', w: 72, h: 72},
                                type: Lightning.textures.ImageTexture,
                                src: Utils.asset('images/tvguide.png')
                            }                            
                        },
                        RightArrow: {
                            w:36,
                            h:72,
                            texture: {
                                resizeMode: {type: 'cover', w: 36, h: 72},
                                x:216,y:0,w:72, h:144,
                                type: Lightning.textures.ImageTexture,
                                src: Utils.asset('images/arrows.png')
                            }
                        },
                    }
                },
                Info: {
                    w: 1920,
                    h: 250,
                    y:830,
                    flex: { margin: 0 },
                    ProgramImage: {
                        w: 448,
                        h: 250,
                        Img: undefined
                    },
                    InfoContainer: {
                        x:20,
                        y:-60,
                        flex: { direction: 'column' },
                        ItemMetadataWrapper: {
                            flex: { direction: 'row', alignItems:'flex-end', wrap: false},
                            rect: true, color: 0x00000000,
                            ProgressWrapper: {
                                w: 1000,
                                h: 60,
                                flex: { direction: 'row', alignItems:'center', padding:10},
                                ProgStartTime: {
                                    h: 30,
                                    w:100,
                                    text: { text: '', fontSize: 24, fontFace: "Light",textAlign:"left" }
                                },
                                Progressbar: {
                                    w: 800,
                                    type: ProgressBar,
                                    progress: 0,
                                    style: {                                        
                                        height: 8,
                                        barColor: 0xffffffff,
                                        progressColor: 0xffff0000,
                                        radius: 0
                                    }
                                },
                                ProgEndTime: {
                                    h: 30,
                                    w: 100,
                                    text: { text: '', fontSize: 24, fontFace: "Light", textAlign:"right" }
                                },
                                Playing: {
                                    x:20,
                                    w:172,
                                    h:42,
                                    visible:false,
                                    type: Badge, title: 'Now Playing', style: { paddingX: 12, paddingY: 10, strokeWidth: 3, radius:0, backgroundColor: 0x00000000, strokeColor: 0xff91FC91, textStyle: { fontSize: 26, textColor: 0x99ffffff } }
                                }
                            }
                        },
                        Title: { text: { text: 'No Data', fontSize: 36, fontFace: Helper.getFontFamily('Regular'),  wordWrapWidth: 1300, maxLines: 1, maxLinesSuffix: '...', textOverflow: 'ellipsis' }, color: 0xffffffff },
                        AgeRating: { text: { text: ' ', fontSize: 24, fontFace: Helper.getFontFamily('Regular') }, color: 0xffffffff },
                        Description: { text: { text: ' ', fontSize: 24, fontFace: Helper.getFontFamily('Regular'), wordWrapWidth: 1300, maxLines: 2, maxLinesSuffix: '...', textOverflow: 'ellipsis', lineHeight: 47, letterSpacing: 0.5 } },
                    }
                },
                EPGGuide: {
                    y:1080,
                    w:1920,
                    h:538,
                    type: EPGGuide
                }
            }
        }
    }


    /** setup the epg guide on the video inisitlization
     * will get the epg manager from app-model where
     * it returns the value epgmanager if it is the same url.
     * initializing the epgmanager and listern to the events.
     * @inheritdoc
     */
    override _init() {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        this.grid = app?.navigation.getCurrentGrid()!
        this.channelIndex = this.grid.getFocusInfo().foucsItem
        this.channelRow = this.grid.getRowAt(this.grid.getFocusInfo().focusRow)!
        this.channelRow.fetchMoreVideos(this.channelRow.totalPages - 1) //loading the last page for rotating the channels
        Logger.printLog('data', '_init: this.channelRow ', this.channelRow);
        this._setupVideoPlayer()
        this._setupEpg()
        
        // this.epgManager.init(this.channelIndex)
    }

    override _firstActive() {
        //this.epgManager.init(this.channelIndex)
        this.videoInfo = this.grid.getFocusedItem()
        this.upateChannelFocus(true)
        this.epgManager.init(this.channelIndex)
    }

    _setupEpg() {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        this.epgManager = app?.loadEpg(this.channelRow.url,this.channelRow,this.channelIndex)!
        this.epgManager.on('onEpgLoaded', this.onEpgLoaded.bind(this))
        this.epgManager.on('onCurrentTime', this.onEpgCurrentTime.bind(this))
        this.epgManager.on('onProgramChanged', this.onEpgProgramChange.bind(this))
        this.epgManager.on('onTimeupdate', this.onEpgTimeupdate.bind(this))
    }


    /**
     * clear the resources for the video screen and goes back to the
     * previous page.
     */
    override _detach() {
        if(this.epgManager) {
            this.epgManager.removeAllListeners('onEpgLoaded')
            this.epgManager.removeAllListeners('onCurrentTime')
            this.epgManager.removeAllListeners('onProgramChanged')
            this.epgManager.removeAllListeners('onTimeupdate')
            this.epgManager.destroy()
            this.epgManager = null;
        }
        this.resetPlayer();
        this.stage.gc()
    }

    /**
     * Event fires when the EPG is initialized and the current selected epg is available.
     */
    onEpgLoaded() {
        Log.info('EPG Loaded')
        this.tag('EPGGuide').epg = this.epgManager
    }

    /**
     * will be dispatched when the current time is changed
     * will be updated every minute.
     *
     * @param {CustomEvent} event
     */
    onEpgCurrentTime(event:CustomEvent) {
        Log.info('EPG Timeupdate: ', event)
        this.tag('EPGGuide')._updateCurrentTime(event.detail.currDate)
    }


    /**
     * will be dispatched when the program changes within a channel or if channel changes.
     * CustomEvent will have previous program details and next program change details.
     * will be used for logging the live video logging.
     *
     * @param {CustomEvent} event
     */
    onEpgProgramChange(event:CustomEvent) {
        Log.info('EPG onProgramChanged: ', event)
        const {prev, next}  = event.detail.channelInfo;

        const { appState} = AppData as AppSetup;
        const app = appState?.getApp();
        let previousVodInfo:PreviousVodInfo = app.navigation.getPreviousVideoInfo()!;
        if (previousVodInfo) {
            let wd = Math.round((new Date().getTime() - this.channelStartTimestamp)/1000)
            if(wd > previousVodInfo.vodInfo.runtime) {
                wd = previousVodInfo.vodInfo.runtime
            }
            app?.navigation.setPreviousVideoWatchDuration(wd)
            Logger.logNextPrevVideoView(next, previousVodInfo);
        } else {
            Logger.logNewVideoView(next);
        }
        this.channelStartTimestamp = new Date().getTime()
        app?.navigation.setPreviousVideoInfo(next)
        this.updateInfo(next)
        this.tag('EPGGuide').updateEpgChannel(next)
    }

    /**
     * will be dispatched every 10 seconds for updaing progressbar.
     *
     * @param {CustomEvent} event
     */
    onEpgTimeupdate(event:CustomEvent) {
        const { appState} = AppData as AppSetup;
        const app = appState?.getApp();
        let previousVodInfo:PreviousVodInfo = app.navigation.getPreviousVideoInfo()!;
        if (previousVodInfo) {
            const vodInfo = previousVodInfo.vodInfo
            const dur = (vodInfo.end_timeObj - vodInfo.start_timeObj)
            const cur = (this.epgManager.currDate-vodInfo.start_timeObj)
            this.tag('Progressbar').progress = cur/dur;
        }
    }

    showControls() {
        this.tag('Background').setSmooth('alpha',1)
        this.tag('ChannelsWrapper').setSmooth('alpha',1)
        this.tag('Info').setSmooth('alpha',1)
        this.$hideEpgGuide()
        clearInterval(this.showControlTimerId)
        this.showControlTimerId = setTimeout(()=>{
            this.hideControls()
        }, this.SHOW_CONTROL_DELAY)
    }

    hideControls() {
        this.tag('Background').setSmooth('alpha',0)
        this.tag('ChannelsWrapper').setSmooth('alpha',0)
        this.tag('Info').setSmooth('alpha',0)
        clearInterval(this.showControlTimerId)
    }

    updateUI() {
        const ih = 210
        const iw = 270
        const img = this.channelRow.videos[this.channelIndex]?.main_picture
        this.tag('ChannelLogo').patch({
            ChannelLogo: {
                w:270,
                h:210,
                rect:true,
                color: 0x00000000,
                Image: {
                    x:iw/2,
                    y: ih/2,
                    mount:0.5,
                    texture: {
                        src: img,
                        resizeMode: {
                            type: 'contain',
                            h: 180,
                            w: 180
                        },
                        type: Lightning.textures.ImageTexture
                    },
                }
            }
        })
        this.tag('ChannelCounter').text.text = `Ch - ${this.channelIndex + 1}`
        this.showControls()
    }

    updateInfo(selected) {
        if(!this.epgManager.loaded) return
        //console.log('updateInfo : ', selected)
        if(selected.id ==-1) {
            this.tag('Title').text.text='No Data'
            this.tag('AgeRating').text.text='NR'
            this.tag('ProgStartTime').text.text = '--:--'
            this.tag('ProgEndTime').text.text = '--:--'
            this.tag('Description').text.text = ''
            this.tag('Playing').visible = EPGUtility.isPlaying(selected?.start_timeObj,selected?.end_timeObj, this.epgManager.currDate)
        } else {
            this.tag('Title').text.text=selected.title || ''
            this.tag('AgeRating').text.text=selected.rating
            this.tag('ProgStartTime').text.text = EPGUtility.formatAMPM(selected?.start_timeObj)
            this.tag('ProgEndTime').text.text = EPGUtility.formatAMPM(selected?.end_timeObj)
            this.tag('Description').text.text = selected.description
            this.tag('Playing').visible = EPGUtility.isPlaying(selected?.start_timeObj,selected?.end_timeObj, this.epgManager.currDate)
        }
        this.updateImage(selected.image)
    }

    updateImage(url) {
        this.tag('ProgramImage').patch({
            Img: undefined
        })
        this._imgUrl = url
        clearTimeout(this.imageUpdateId)
        this.imageUpdateId = setTimeout(()=>{
            this.tag('ProgramImage').patch({
                Img: {
                    w: 448,
                    h: 250,
                    src: getImage(this._imgUrl)
                }
            })
        },500)
    }

    canHandlekeyPress() {
        const nextKeyActionTimeStamp = new Date().getTime()
        if (nextKeyActionTimeStamp > (this.prevKeyActionTimeStamp + this.CHANNEL_SCROLL_DELAY)) {
            this.prevKeyActionTimeStamp = nextKeyActionTimeStamp
            return true
        }
        return false
    }

    changeChannel(forcePlay = false) {
        clearTimeout(this.changeChannelTimerId);
        this.changeChannelTimerId = setTimeout(() => {
            this.epgManager.changeChannel(this.channelIndex)
            const prevVideoInfoNodeId = this.videoInfo.node_id
            this.videoInfo = this.grid.getFocusedItem()
            if(forcePlay || (prevVideoInfoNodeId !== this.videoInfo.node_id)) {
                //this.resetPlayer()
                this.resumePlayer()
            }
        }, this.CHANNEL_CHANGE_DELAY)

        return true
    }

    _getActionKey() {
        if (this.videoInfo) {
            return `${this.videoInfo.node_id}_${Math.round((new Date().getTime() - this.channelStartTimestamp)/1000)}`
        }
        return ''
    }

    //----------------Video player setup and handling code section.
    _setupVideoPlayer() {
        let el = document.getElementById("content-player");
        let elw = document.createElement('content-player-wrapper');
        if (!el) {
            elw = document.createElement('div');
            elw.setAttribute('id', 'content-player-wrapper')
            elw.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;background-color: #000;display:none;')
            el = document.createElement("video")
            el.id = 'content-player'
            el.style.width = '100%'
            el.style.height = '100%'
            el.setAttribute("crossorigin", "anonymous");
            el.setAttribute("autoplay", "false");
            elw.appendChild(el)
            let subtitle = document.createElement('div')
            subtitle.id = 'subtitle'
            subtitle.setAttribute('style', 'position: absolute;bottom: 90px;left: 10px;text-align: center;max-width: 1900px;right: 10px;display: none;')
            subtitle.innerHTML = '<span></span>'
            elw.appendChild(el)
            elw.appendChild(subtitle)
            document.body.appendChild(elw)
        }
        this.videoEl = el as HTMLVideoElement
        this.videoElWrapper = elw as HTMLElement
        const options = {
            debug: false,
            enableWebVTT: true,
            liveMaxLatencyDurationCount: 10,//sec
            liveSyncDurationCount: 5,
            lowLatencyMode: true,
            startLevel:0,
            backBufferLength: 5
        }
        this.ftStreamingPlayer = new Hls(options)
        this.ftStreamingPlayer.attachMedia(this.videoEl)
        this.ftStreamingPlayer.on(Hls.Events.MANIFEST_PARSED, () => {
            this.videoEl.play()
          });
        //this.ftStreamingPlayer = FTStreamingPlayer.getInstance(this.videoEl)
    }

    _setEventListeners() {
        ftEvents.map(event => {
            this.videoEl.addEventListener(event, this._handleFtPlayerEvents)
        })
        this.videoEl.addEventListener('playererror', this._handleFtPlayerEvents)
    }

    _removeEventListener() {
        ftEvents.map(event => {
            this.videoEl.removeEventListener(event, this._handleFtPlayerEvents)
        })
        this.videoEl.removeEventListener('playererror', this._handleFtPlayerEvents)
    }

    _handleFtPlayerEvents = (event: any) => {
        if (event.type !== 'progress' && event.type !== 'timeupdate') { Log.info('PlayerEvent:', event.type) }
        switch (event.type) {
            case 'loadedmetadata':
                this.setPlayerState(PLAYERSTATE.READY)
                break;
            case 'pause':
                this.setPlayerState(PLAYERSTATE.PAUSED)
                break;
            case 'waiting':
                this.setPlayerState(PLAYERSTATE.PLAYING) // Pause Button should be displayed ony on the pause action not in waiting.
                break;
            case 'playing':
                this.setPlayerState(PLAYERSTATE.PLAYING)
                break;
            case 'ended':
                //this.$next()
                break;
            case 'error':
            case 'playererror':
                Log.info('playererror: ', event)
                this.handlePlayerError(event)
                break;
            case 'timeupdate':
                break;
        }

    }

    getErrorCode(error: any) {
        let code = '';
        try {
            code = error.detail.message.error.code
        } catch (e) {

        }
        return code;
    }

    getErrorMsg(error: any) {
        let msg = '';
        try {
            msg = error.detail.message.error.message
        } catch (e) {

        }
        return msg;
    }

    getErrorXhr(error: any) {
        try {
            return error.detail.message.error.data
        } catch (e) {
            return null
        }
    }
    
    handlePlayerError(error: CustomEvent) {
        let errType = '';
        let errorDetailStr = '';
        let isFatal = false
        const { appState, platform } = AppData as AppSetup;
        try {
            if (error) {
                if (error.detail && error.detail.type) {
                    if (error.detail.type == 'M(PEG)-DASH') {
                        let errorDetail = {
                            type: 'dashError',
                            message: this.getErrorMsg(error),
                            errorCode: this.getErrorCode(error)
                        }
                        errType = 'Dash';
                        errorDetailStr = JSON.stringify(errorDetail);
                        isFatal = true
                    } else if (error.detail.type == "HLS") {
                        errType = error.detail.type;
                        var errorDetail = {
                            type: error.detail.type,
                            message: error.detail.message
                        }
                        errorDetailStr = JSON.stringify(errorDetail);
                        isFatal = error.detail.data[1].fatal
                    } else if (error.detail.type == "MP4") {
                        isFatal = true
                        errType = error.detail.type;
                    }
                }
                Logger.processUserAction('playbackfailed', this._getActionKey(), errType, errorDetailStr);
                //platform?.networkManager.healthCheck(true, this, { success: null, failed: null }) // currently disabling the health check.
                if (isFatal) {
                    Log.info('Video Error: ', error)
                    //XFIN-703 -  sendin gthe error metrics to platform which in turn will send the metrics to appropriate device api
                    // example for comcast it will send the error metrics to Firebolt.
                    platform?.sendMetrics('error', {errorType: 'network', code: errType, description:errorDetailStr})
                    //dataObj.errorType, dataObj.code, dataObj.description
                }
            }
        } catch (e) {

        }
    }

    setPlayerState(playerState: PLAYERSTATE) {
        const { appState } = AppData as AppSetup
        if (playerState == PLAYERSTATE.READY) {
            appState.eventInProgress = false;
            // this.showHideVideoLoading(false)
        } else if (playerState == PLAYERSTATE.PLAYING) {

        } else if (playerState == PLAYERSTATE.PAUSED) {

        } else if (playerState == PLAYERSTATE.FF) {

        } else if (playerState == PLAYERSTATE.REW) {

        }
        this.playerState = playerState //assign the new playlist
    }

    resetPlayer() {
        this._removeEventListener()
        this.ftStreamingPlayer.detachMedia()
        this.ftStreamingPlayer.destroy()
        this.setPlayerState(PLAYERSTATE.NONE)
        this.hideVideo()
    }

    resumePlayer(resumeTime = 0) {
        Log.info("videoInfo ", this.videoInfo);
        //const options = new FTPlayerOptions()
        this.videoUrl = this.videoInfo.video_url!;

        const { appState} = AppData as AppSetup;
        const app:AppModel = appState?.getApp()!
        app.imaAdHandler.currentVodInfo = this.videoInfo
        this.videoUrl = app.imaAdHandler.replaceMacros(this.videoUrl)

        Log.info("videoUrl ", this.videoUrl);
        this.setPlayerState(PLAYERSTATE.INITIALIZING)
        //const drm = await Helper.getDrmObj(this.videoInfo)
        // const hlsOptions = {
        //     debug: false,
        //     liveMaxLatencyDurationCount: 5,//sec
        //     liveSyncDurationCount: 3,
        //     lowLatencyMode: true,
        //     startLevel:0,
        //     backBufferLength: 5
        // };
        // const hlsUrl = { src: this.videoUrl, type: 'application/x-mpegURL', options: options };

        // let src
        // options.hls = hlsOptions;
        // hlsUrl.src = hlsUrl.src
        // src = hlsUrl;

        // this._removeEventListener()
        //this._setEventListeners()
        //this.ftStreamingPlayer.src = src
        this.ftStreamingPlayer.loadSource(this.videoUrl)
        this.showVideo()
    }

    hideVideo() {
        //VideoPlayer.hide();
        if ($('#content-player-wrapper')) {
            $('#content-player-wrapper').hide()
        }
    }

    showVideo() {
        if ($('#content-player-wrapper')) {
            $('#content-player-wrapper').show()
        }
    }

    upateChannelFocus(forcePlay = false) {
        const focusInfo = this.grid.getFocusInfo()
        focusInfo.foucsItem = this.channelIndex
        this.grid.changeFocus(focusInfo)
        this.updateUI()
        this.changeChannel(forcePlay)
    }

    $changeChannel(channelIndex) {
        //console.log('EPG $changeChannel', channelIndex)
        this.channelIndex = channelIndex
        this.upateChannelFocus()
    }

    override _handleDown() {
        if (this.canHandlekeyPress()) {
            if (this.channelIndex == this.channelRow.videosCount - 1) {
                this.channelIndex = 0
            } else {
                this.channelIndex++
            }
            this.upateChannelFocus()
        }
        return true
    }

    hitCloseTracker() {
        const { appState} = AppData as AppSetup;
        const app = appState?.getApp();
        let previousVodInfo:PreviousVodInfo = app?.navigation.getPreviousVideoInfo()!;
        if (previousVodInfo) {
            let wd = Math.round((new Date().getTime() - this.channelStartTimestamp)/1000)
            // if(previousVodInfo.vodInfo.runtime < wd) {
            //     wd = previousVodInfo.vodInfo.runtime
            // }
            app?.navigation.setPreviousVideoWatchDuration(wd)
            Logger.logCloseVideoView(previousVodInfo);
            app.navigation.resetPreviousVideoInfo()
        }
    }

    closeVideo() {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this.hitCloseTracker()
        this.resetPlayer()
    }

    override _handleBack() {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this.closeVideo()
        app?.handleBackNavigation();
        return true
    }

    override _handleUp() {
        if (this.canHandlekeyPress()) {
            if (this.channelIndex == 0) {
                this.channelIndex = this.channelRow.videosCount - 1
            } else {
                this.channelIndex--
            }
            this.upateChannelFocus()
        }
        return true
    }

    override _handleRight() {
        this.showControls()
        return true
    }

    override _handleLeft() {
        this.showControls()
        return true
    }

    override _getFocused() {
        this.showControls()
        return this
    }

    override _handleEnter() {
        this._setState('EpgGuideState')
        return true
        // Overwrites root function when we are on this state
    }

    override _handleKey(e: KeyboardEvent): boolean | void {
        let action: string = '';

        switch (e.keyCode) {
            //media controls key
            case KeyCodes.KEY_NEXT:
                this._handleDown()
                break;
            case KeyCodes.KEY_PREVIOUS:
                this._handleUp()
                break;
            case KeyCodes.KEY_EXIT:
                this.hitCloseTracker();
                Logger.processUserAction('userExitedViaRemoteDirectly', this._getActionKey());
                break;
            case KeyCodes.KEY_HOME:
                this.hitCloseTracker();
                Logger.processUserAction('userExitedViaRemoteDirectly', this._getActionKey());
                break;
        }
    }

    $hideEpgGuide() {
        this._setState('')
    }

    static override _states() {
        return [
            class EpgGuideState extends this {
                override $enter(event) {
                    this.hideControls()
                    this.tag('EPGGuide').setSmooth('y', 542)
                }
                override $exit(event) {
                    this.tag('EPGGuide').setSmooth('y', 1080)
                }
                override _getFocused() {
                    return this.tag('EPGGuide')
                }
                override _handleKey() {
                    return true
                    // Overwrites root function when we are on this state
                }
                // override _handleEnter() {
                //     this.tag('EPGGuide').handleEnter()
                //     return true
                //     // Overwrites root function when we are on this state
                // }
                override _handleBack() {
                    this._setState('')
                    return true
                    // Overwrites root function when we are on this state
                }
            }
        ]
    }
}
